import React from "react";

import CloseIcon from "@mui/icons-material/Close";
import { Button, IconButton, Modal, Stack, Typography } from "@mui/material";
import { ISelectDealFolderModal } from "store/types/modals";

import { DealSelect } from "./components/DealSelect";
import { FolderSelect } from "./components/FolderSelect";
import { useSelectDealFolderHook } from "./hooks/useSelectDealFolder";

export const SelectDealFolderModal: React.FC<ISelectDealFolderModal> = ({
  isOpen,
  preselectedDeal,
  title,
  onSubmit,
  onClose,
  isGeneralDocument
}) => {
  const {
    deal,
    setDeal,
    step,
    setStep,
    selectedFolder,
    setSelectedFolder,
    hasNewFolder,
    loading,
    folders,
    handleOutsideUnselect,
    onCreateNewFolder,
    onSelectHandle,
    onCloseModal,
    isSelectDisabled
  } = useSelectDealFolderHook({ onSubmit, preselectedDeal, onClose, isGeneralDocument });

  const isStepSelectDeal = step === "select-deal";
  const isStepSelectFolder = step === "select-folder";

  return (
    <Modal open={isOpen} onClose={onCloseModal}>
      <Stack
        sx={{
          padding: "32px",
          borderRadius: "8px",
          backgroundColor: "#fff",
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "520px"
        }}
        gap="20px"
        justifyContent="space-between"
        onClick={handleOutsideUnselect}
      >
        <Typography variant="h6" component="div" sx={{ display: "flex", justifyContent: "space-between" }}>
          {title}
          <IconButton onClick={onCloseModal}>
            <CloseIcon />
          </IconButton>
        </Typography>

        {!preselectedDeal && isStepSelectDeal && <DealSelect deal={deal} setDeal={setDeal} />}
        {isStepSelectFolder && (
          <FolderSelect
            deal={deal}
            folders={folders}
            loading={loading}
            selectedFolder={selectedFolder}
            onCreateNewFolder={onCreateNewFolder}
            onStepBack={() => setStep("select-deal")}
            hasNewFolder={hasNewFolder}
            setSelectedFolder={setSelectedFolder}
            isGeneralDocument={isGeneralDocument}
          />
        )}

        <Stack flexDirection="row" alignItems="center" justifyContent="flex-end" gap="10px">
          <>
            <Button variant="outlined" sx={{ minWidth: "53px" }} onClick={onCloseModal}>
              Cancel
            </Button>
            <Button
              disabled={isSelectDisabled}
              variant="contained"
              sx={{ backgroundColor: "#071F35", minWidth: "46px" }}
              onClick={onSelectHandle}
              data-move-document-submit
            >
              Select
            </Button>
          </>
        </Stack>
      </Stack>
    </Modal>
  );
};
